import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import { ChatsService } from '../../shared/services/chats.service';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

import { FormBuilder, FormGroup } from '@angular/forms';
import {MenuItem} from 'primeng/api';

export interface Item { 
  user: string,
  time: any; 
  message: string;
}

@Component({
  selector: 'app-chat-room',
  templateUrl: './chat-room.component.html',
  styleUrls: ['./chat-room.component.scss']
})
export class ChatRoomComponent implements OnInit, AfterViewInit {
  displayAdmin: boolean = false;
  private itemsCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  menuitems: MenuItem[];
  messageForm: FormGroup;

  constructor(
    public authService: AuthService,
    public chatService: ChatsService,
    private afs: AngularFirestore,
    
    private messageAdd: FormBuilder,
  ) { 
    this.itemsCollection = afs.collection<Item>('chats',  ref => ref.orderBy('time', "asc"));
    this.items = this.itemsCollection.valueChanges();
  }

  ngOnInit() {
    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();

    ///Forms
    this.messageForm = this.messageAdd.group({
      title: '',
    });
  }

  ngAfterViewInit(){
    this.menuitems = [
      {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
      {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
      {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
  ]
  }

  adminContent(){
    if(this.authService.adminContent == true){
      this.displayAdmin = true;
    }else{
      this.displayAdmin = false;
    }
  }

  addMessageForm(){
    this.chatService.addMessage(this.messageForm.value.title);
  }

}
